import React from 'react';
import { FlatList } from 'react-native';
export const FlashList = React.forwardRef((props, ref) => {
    const { renderScrollComponent, renderItem, onViewableItemsChanged, CellRendererComponent, ...rest } = props;
    return (React.createElement(FlatList, { renderItem: renderItem, onViewableItemsChanged: onViewableItemsChanged, onScrollToIndexFailed: () => { }, ...rest, ref: ref }));
});
//# sourceMappingURL=FlashList.web.js.map